import {
  easypostFedexMfaValidateInvoiceInputSchema,
  easypostFedexMfaValidateInvoiceOutputSchema,
} from "@redotech/redo-model/carrier-account/easypost-fedex-mfa";

export const easypostFedexMfaValidateInvoice = {
  name: "easypostFedexMfaValidateInvoice" as const,
  input: easypostFedexMfaValidateInvoiceInputSchema,
  output: easypostFedexMfaValidateInvoiceOutputSchema,
};
